import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DepotInsight } from '../models/depot-insight.model';

@Injectable({
  providedIn: 'root',
})
export class DepotInsightService {
  getDepotInsightData(): Observable<DepotInsight[]> {
    const depotInsightData: DepotInsight[] = [
      {
        reg: 'DE73SLT',
        model: 'Ford eTransit',
        status: 'VOR',
        vorReason: 'Defect #10-678976',
        arrivedDate: '29/01/2024 1000',
        leaveDate: '4/02/2024 0500',
        daysAtRepairer: 7,
        notes: 'Engine needed replacing',
      },
      {
        reg: 'YG69LXS',
        model: 'MAN TGE',
        status: 'VOR',
        vorReason: 'Defect',
        arrivedDate: '29/01/2024 0500',
        leaveDate: '2/02/2024 0500',
        daysAtRepairer: 5,
        notes: '',
      },
      {
        reg: 'MAN TGE',
        model: '1',
        status: 'MOT',
        vorReason: '28/01/2024 1624',
        arrivedDate: '28/01/2024 1624',
        leaveDate: '1/02/2024 0500',
        daysAtRepairer: 4,
        notes: '',
      },
      {
        reg: 'YG69LXD',
        model: 'Mercedes Sprinter',
        status: 'VOR',
        vorReason: 'Defect #10-678965',
        arrivedDate: '27/01/2024 0835',
        leaveDate: '28/01/2024 0835',
        daysAtRepairer: 1,
        notes: '',
      },
      {
        reg: 'YG70TSV',
        model: 'Ford eTransit',
        status: 'VOR',
        vorReason: 'MOT',
        arrivedDate: '29/01/2024 0500',
        leaveDate: '31/01/2024 0500',
        daysAtRepairer: 2,
        notes: '',
      },
      {
        reg: 'DE73SLT',
        model: 'Ford eTransit',
        status: 'VOR',
        vorReason: 'Defect #10-678900',
        arrivedDate: '29/01/2024 1022',
        leaveDate: '29/01/2024 1022',
        daysAtRepairer: 1,
        notes: '',
      },
    ];
    return of(depotInsightData);
  }
}
